<template>
  <div :class="!_isMobile ? 'mt88' : 'warpMt'">
    <img :class="_isMobile ? 'bannerStyleM' : 'bannerStylePc'"
      :src="_isMobile ? 'https://cdn.youjiajk.com/newsBannerMobile.png' : 'https://cdn.youjiajk.com/newsBannerPc1_new.png'" />
    <newsPc v-if="!_isMobile" :newsList="newsList" :totalCount="totalCount" :currentIndex="currentIndex" :size="size"
      @searchEmit="searchEmit" :swiperList="swiperList"></newsPc>
    <newsMobile v-else :newsList="newsList" :totalCount="totalCount" :currentIndex="currentIndex" :size="size"
      @searchEmit="searchEmit" :swiperList="swiperList"></newsMobile>
  </div>
</template>

<script>
import newsPc from './pc/newsPc.vue'
import newsMobile from './mobile/newsMobile.vue'
import customizedService from '../components/customizedServicePc.vue'
import axios from 'axios'
export default {
  metaInfo () {
    return {
      meta: [
        {
          name: 'title',
          content: '优加健保健康科技 ( 北京 ) 有限公司'
        },
        {
          name: 'keywords',
          content: '优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
        },
        {
          name: 'description',
          content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
        }
      ]
    }
  },
  data () {
    return {
      _isMobile: false,
      newsList: [],
      currentIndex: 1,
      size: 10,
      totalCount: 0,
      swiperList: [{
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic2.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic3.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic4.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic5.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic6.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic7.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic8.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic9.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic10.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic11.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic12.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic1.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic13.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic14.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic15.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic16.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic17.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic18.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic19.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjjk/yjrk_pic20.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjrk_pic21.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjrk_pic22.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjrk_pic23.png'
      }, {
        url: 'https://cdn.youjiajk.com/yjrk_pic24.png'
      },
      { url: 'https://cdn.youjiajk.com/yjrk_pic25.png' },

      { url: 'https://cdn.youjiajk.com/yjrk_pic27.png' },
      { url: 'https://cdn.youjiajk.com/yjrk_pic30.png' },
      { url: 'https://cdn.youjiajk.com/yjrk_pic28.png' },
      { url: 'https://cdn.youjiajk.com/yjrk_pic29.png' },
      { url: 'https://cdn.youjiajk.com/yjrk_pic26.png' },
      ],
    }
  },
  components: {
    newsPc,
    newsMobile,
    customizedService
  },
  created () {
    this._isMobile = this.$util._isMobile()
    this.search()
  },
  methods: {
    search () {
      axios.post('https://ums.youjiajk.com/website/news/search', {
        page: this.currentIndex,
        size: this.size
      }).then(res => {
        if (res.data.code == 0) {
          this.newsList = res.data.data.list
          this.totalCount = res.data.data.total
        }
      })
    },
    searchEmit (type, val) {
      if (type == 'size') {
        this.size = val
      }
      if (type == 'index') {
        this.currentIndex = val
      }
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.bannerStyleM {
  width: 100%;
  // height: 2.85rem;
  object-fit: cover;
}

.bannerStylePc {
  width: 100%;
  // height: 285px;
  object-fit: cover;
}

.mt88 {
  margin-top: 88px;
}

.warpMt {
  margin-top: 1.55rem;
}
</style>



// WEBPACK FOOTER //
// src/views/news.vue